// Libs
import React from "react";
import { useQueryParam, StringParam } from "use-query-params";

// Components
import Subcategory from "./subcategories/Subcategory";

// Static Data
import { allCategories } from "./staticCategories";

// Style
import { Container } from "./SubcategoriesStyle";

const Subcategories = () => {
  // query parameters with serialization
  const category = useQueryParam("category", StringParam)[0];
  const querySubcategory = useQueryParam("subcategory", StringParam)[0];
  const setSubcategory = useQueryParam("subcategory", StringParam)[1];

  const getSubcategories = () => {
    const currentSubcategory = allCategories().find(
      staticCategory => staticCategory.value === category
    );

    return Object.keys(currentSubcategory).includes("subcategories")
      ? currentSubcategory.subcategories
      : [];
  };

  return (
    <Container>
      {getSubcategories().length > 0 &&
        getSubcategories().map(subcategory => {
          return (
            <Subcategory
              checked={querySubcategory === subcategory.name}
              key={subcategory.name}
              onClick={() => setSubcategory(subcategory.name, "pushIn")}
            >
              {subcategory.label}
            </Subcategory>
          );
        })}
    </Container>
  );
};

export default Subcategories;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/Subcategories.js